module.exports = __webpack_public_path__ + "static/media/ios-man.512dd1d1.svg";